import { modules } from 'veritone-redux-common';

const {
  config: { getConfig },
  user
} = modules;

function initSegment(state, page) {
  let analytics = (window.analytics = window.analytics || []);
  if (!analytics.initialize && !analytics.invoked) {
    analytics.invoked = !0;
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on'
    ];
    analytics.factory = function(t) {
      return function() {
        let e = Array.prototype.slice.call(arguments);
        e.unshift(t);
        analytics.push(e);
        return analytics;
      };
    };
    for (let t = 0; t < analytics.methods.length; t++) {
      let e = analytics.methods[t];
      analytics[e] = analytics.factory(e);
    }
    analytics.load = function(t, e) {
      let n = document.createElement('script');
      n.type = 'text/javascript';
      n.async = !0;
      n.src =
        'https://cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js';
      let a = document.getElementsByTagName('script')[0];
      a.parentNode.insertBefore(n, a);
      analytics._loadOptions = e;
    };
    analytics.SNIPPET_VERSION = '4.1.0';
    analytics.load(getConfig(state).segmentWriteKey);
    analytics.page(page);

    const currentUser = user.selectUser(state);
    analytics.identify(`${currentUser.userId}`, {
      email: currentUser.userName,
    //   'VTN-Attribute': 'True' //uncomment this line to enable Intercom
    });
  }

  return analytics;
}

function initPendo(state) {
  const pendo = (window.pendo = window.pendo || []);
  if (pendo.initialize) {
    return;
  }

  const currentUser = user.selectUser(state);
  const userGroup = currentUser.groups[0];
  const organization = currentUser.organization;
  const config = getConfig(state);
  const pendoKey = config.pendoKey
  const visitor = {
    id: user.userId,
    email: user.userName
  };
  const account = {
    id: userGroup.groupId,
    groupname: userGroup.groupName,
    organizationId: organization.organizationId,
    organizationName: organization.organizationName
  };

  // pendo init magic
  (function(apiKey) {
    (function(p, e, n, d) {
      let v, w, x, y, z;
      let o = (p[d] = p[d] || {});
      o._q = [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
      for (w = 0, x = v.length; w < x; ++w) {
        (function(m) {
          o[m] =
            o[m] ||
            function() {
              o._q[m === v[0] ? 'unshift' : 'push'](
                [m].concat([].slice.call(arguments, 0))
              );
            };
        })(v[w]);
      }

      y = e.createElement(n);
      y.async = !0;
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
    window.pendo.initialize({
      visitor: visitor,
      account: account
    });
  })(pendoKey);
}

export const getSegment = initSegment;

export const getPendo = state => {
  initPendo(state);
  return window.pendo;
};


export const getPendoWithoutAuth = state => {
  const pendo = (window.pendo = window.pendo || []);
  if (pendo.initialize) {
    return;
  }

  const config = getConfig(state);
  const pendoKey = config.pendoKey;

  // pendo init magic
  (function(apiKey) {
    (function(p, e, n, d) {
      let v, w, x, y, z;
      let o = (p[d] = p[d] || {});
      o._q = [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
      for (w = 0, x = v.length; w < x; ++w) {
        (function(m) {
          o[m] =
            o[m] ||
            function() {
              o._q[m === v[0] ? 'unshift' : 'push'](
                [m].concat([].slice.call(arguments, 0))
              );
            };
        })(v[w]);
      }

      y = e.createElement(n);
      y.async = !0;
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
    const visitor = {
      id: ''
    }
    window.pendo.initialize({
      visitor
    });
  })(pendoKey);

  return window.pendo;
}
